import React, { useState } from 'react';
import Alert, { AlertProps } from '@mui/material/Alert';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import Snackbar from '@mui/material/Snackbar';
import { Z_INDEX_MAX } from 'src/constants';

interface Props extends AlertProps {
  submitSuccessMessage: string;
}

const EmailSuccessMessage = ({ submitSuccessMessage, ...rest }: Props) => {
  const [showSubmitSuccessMessage, setShowSubmitSuccessMessage] = useState(true);
  return (
    <Snackbar
      open={showSubmitSuccessMessage}
      onClose={() => setShowSubmitSuccessMessage(false)}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      autoHideDuration={6000}
      sx={{
        maxWidth: {
          sm: 'calc(100vw - 32px)',
        },
        zIndex: Z_INDEX_MAX,
        right: {
          sm: 16,
        },
      }}
    >
      <Alert severity="success" elevation={1} icon={<MarkEmailReadIcon />} {...rest}>
        <span className="bp-font-primary-smaller !bp-leading-[22px]">{submitSuccessMessage}</span>
      </Alert>
    </Snackbar>
  );
};

export default React.forwardRef(EmailSuccessMessage);
